import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const Dropdown: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path fillRule="evenodd" clipRule="evenodd" d="M12 16L6.29289 10.2929C5.90237 9.90237 5.90237 9.2692 6.29289 8.87868C6.68342 8.48816 7.31658 8.48816 7.70711 8.87868L12 13.1716L16.2929 8.87868C16.6834 8.48816 17.3166 8.48816 17.7071 8.87868C18.0976 9.2692 18.0976 9.90237 17.7071 10.2929L12 16Z" fill={color} />
</svg>);
export default Dropdown;